/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState } from 'react';

import { BACK_TO_RESULTS } from '../../analyticsConsts';
import { useScrollDirectionContext } from '../../context/scrollDirection';
import publicPath from '../../utils/publicPath';
import { ClubBackArrow } from '../Icons';
import Image from '../Image';
import Link from '../Link';
import LinkDirection from '../LinkDirection';
import Text from '../Text';
import useStyles from './styles';

const ClubDetailsHeroProvider = forwardRef(
  (
    {
      hasPreferences,
      textSize = 1,
      images,
      overlayVariation = 4,
      title,
      address,
      distance,
      latitude,
      longitude,
      type,
      county,
      accreditation,
      analyticsId,
      titleHeight,
      isInternalLink = false,
      onClick,
      previousPageData,
      sourceLoction,
      Category,
      backupUrl,
      isTeamPage,
      selectedRecommendationType,
      isDesktop,
      ...rest
    },
    titleRef,
    isvenue = 'false'
  ) => {
    const styles = useStyles();
    const [hasLoaded, setHasLoaded] = useState(false);
    const { scrolldirectionContext } = useScrollDirectionContext();

    useEffect(() => {
      setTimeout(() => {
        setHasLoaded(true);
      }, 300);
    }, []);

    return (
      <div css={styles.heroWrapper}>
        <div
          css={styles.hero(images, overlayVariation, scrolldirectionContext)}
          {...rest}
        >
          <div css={styles.textWrapper(hasLoaded, isvenue)} {...rest}>
            <div css={styles.providerWrapper}>
              <div
                css={styles.infoWrapper(!hasPreferences, titleHeight, isvenue)}
                ref={titleRef}
              >
                {(!!selectedRecommendationType || Category) && (
                  <Link
                    id={BACK_TO_RESULTS}
                    to={previousPageData?.backUrl}
                    css={styles.backLink}
                  >
                    <ClubBackArrow />{' '}
                    <span> Back to {isTeamPage ? 'club' : 'results'} </span>
                  </Link>
                )}
                {(isTeamPage && !selectedRecommendationType) && (
                  <a
                    id={BACK_TO_RESULTS}
                    href={sessionStorage.getItem('backLinkClub')}
                    css={styles.backLink}
                  >
                    <ClubBackArrow />{' '}
                    <span> Back to {'club'} </span>
                  </a>
                )}

                {(sessionStorage.getItem('backLinkResults') !== null) && (!isTeamPage && !selectedRecommendationType) && (
                  <a
                    id={BACK_TO_RESULTS}
                    href={sessionStorage.getItem('backLinkResults')}
                    css={styles.backLink}
                  >
                    <ClubBackArrow />{' '}
                    <span> Back to {'results'} </span>
                  </a>
                )}

                <div css={styles.titleWithLogo}>
                  <div css={styles.heroLogo}>
                    <Image
                      css={styles.image}
                      alt="Club logo"
                      src={publicPath(
                        isDesktop
                          ? `/images/desktop/club/hero/club-ef-logo.svg`
                          : `/images/mobile/club/hero/club-ef-logo.svg`
                      )}
                    />
                  </div>
                  {title && (
                    <Text
                      id={analyticsId}
                      as="h1"
                      size={textSize}
                      css={styles.mainText}
                    >
                      {title.toLowerCase()}
                    </Text>
                  )}
                </div>
                <div css={styles.info}>
                  {address && (
                    <LinkDirection
                      latitude={latitude}
                      longitude={longitude}
                      name={title}
                      css={styles.distance}
                      sourceLocation={sourceLoction}
                      isInline
                      aria-label={`Directions to ${title.toLowerCase()} - opens in a new window`}
                    >
                      {address}
                    </LinkDirection>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

ClubDetailsHeroProvider.propTypes = {
  hasPreferences: PropTypes.any,
  textSize: PropTypes.number,
  images: PropTypes.any,
  overlayVariation: PropTypes.number,
  title: PropTypes.string,
  address: PropTypes.string,
  distance: PropTypes.any,
  latitude: PropTypes.any,
  longitude: PropTypes.any,
  type: PropTypes.string,
  county: PropTypes.string,
  accreditation: PropTypes.any,
  analyticsId: PropTypes.string,
  titleHeight: PropTypes.any,
  isInternalLink: PropTypes.bool,
  onClick: PropTypes.func,
  previousPageData: PropTypes.any,
  sourceLoction: PropTypes.any,
  Category: PropTypes.any,
  backupUrl: PropTypes.any,
  isTeamPage: PropTypes.any,
  selectedRecommendationType: PropTypes.any,
  isDesktop: PropTypes.any,
};

export default ClubDetailsHeroProvider;
